const fontItems = ['fontSize', 'fontColor', 'fontBackgroundColor'];
const commentItems = ['inlineComment', '|', 'commentsArchive', '|', 'toggleComments'];
export function documentFormattingToolbarItems() {
    const items = [
        'undo',
        'redo',
        '|',
        'heading',
        ...fontItems,
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        'bulletedList',
        'numberedList',
        'multiLevelList',
        'alignment',
        'pageBreak',
        '|',
        'outdent',
        'indent',
        '|',
        'link',
        'insertImage',
        '|',
        'insertTable',
    ];
    return items;
}
export function documentCollaborativeEditingToolbarItems() {
    return [...commentItems, '|', 'revisionHistory', '|', 'editMode'];
}
export function documentRestrictedToolbarItems() {
    const items = [
        'undo',
        'redo',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        '|',
        'alignment',
        '|',
        'fontColor',
        'fontBackgroundColor',
        '<->',
        ...commentItems,
    ];
    return items;
}
